export const TmcAdmissionsColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Поставщик',
        key: 'companyName',
    },
    {
        name: 'Тип',
        key: 'typeName',
    },
    {
        name: 'Дата создания',
        key: 'createdAt',
    },
    {
        name: 'Код 1С',
        key: 'code1C',
    },
    {
        name: '№ Заявки JIRA',
        key: 'jiraNumber',
        withHint: true,
    },
    {
        name: 'Склад',
        key: 'warehouseName',
    },
    {
        name: 'Доверенность',
        key: 'warrantNumber',
    },
    {
        name: 'Сумма',
        key: 'receiptsTotalPrice',
    },
    {
        name: 'Статус',
        key: 'status',
    },
]
